import React, { Component } from "react";
import { store as storeNotification } from "react-notifications-component";
import { connect } from "react-redux";
import { fileSelectionActions } from "../../../actions/fileUploadActions";
import "./styles.css";

export class Choosefile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			choosefile: false,
			file: null,
			filename: "",
		};

		this.choosefileState = this.choosefileState.bind(this);
	}

	choosefileState(e) {
		console.log("e.target.files[0].type=", e.target.files[0].type);

		let mimeTypes = [
			{ extension: ".aac", mime: "audio/aac" },
			{ extension: ".abw", mime: "application/x-abiword" },
			{ extension: ".arc", mime: "application/x-freearc" },

			{ extension: ".avi", mime: "video/x-msvideo" },
			{ extension: ".azw", mime: "application/vnd.amazon.ebook" },
			{ extension: ".bin", mime: "application/octet-stream" },
			{ extension: ".bmp", mime: "image/bmp" },
			{ extension: ".bz", mime: "application/x-bzip" },
			{ extension: ".bz2", mime: "application/x-bzip2" },
			{ extension: ".csh", mime: "application/x-csh" },
			{ extension: ".css", mime: "text/css" },
			{ extension: ".csv", mime: "text/csv" },
			{ extension: ".doc", mime: "application/msword" },
			{
				extension: ".docx",
				mime:
					"application/vnd.openxmlformats-officedocument.wordprocessingml.document",
			},
			{ extension: ".eot", mime: "application/vnd.ms-fontobject" },
			{ extension: ".epub", mime: "application/epub+zip" },
			{ extension: ".gz", mime: "application/gzip" },
			{ extension: ".gif", mime: "image/gif" },
			{ extension: ".ico", mime: "image/vnd.microsoft.icon" },
			{ extension: ".ics", mime: "text/calendar" },
			{ extension: ".jar", mime: "application/java-archive" },
			{ extension: ".jpeg", mime: "image/jpeg" },
			{ extension: ".jpg", mime: "image/jpeg" },
			{ extension: ".json", mime: "application/json" },
			{ extension: ".jsonld", mime: "application/ld+json" },
			{ extension: ".mjs", mime: "text/javascript" },
			{ extension: ".mp3", mime: "audio/mpeg" },
			{ extension: ".mpeg", mime: "video/mpeg" },
			{ extension: ".mpkg", mime: "application/vnd.apple.installer+xml" },
			{
				extension: ".odp",
				mime: "application/vnd.oasis.opendocument.presentation",
			},
			{
				extension: ".ods",
				mime: "application/vnd.oasis.opendocument.spreadsheet",
			},
			{ extension: ".odt", mime: "application/vnd.oasis.opendocument.text" },
			{ extension: ".oga", mime: "audio/ogg" },
			{ extension: ".ogv", mime: "video/ogg" },
			{ extension: ".ogx", mime: "application/ogg" },
			{ extension: ".opus", mime: "audio/opus" },
			{ extension: ".otf", mime: "font/otf" },
			{ extension: ".png", mime: "image/png" },
			{ extension: ".pdf", mime: "application/pdf" },
			{ extension: ".php", mime: "application/x-httpd-php" },
			{ extension: ".ppt", mime: "application/vnd.ms-powerpoint" },
			{
				extension: ".pptx",
				mime:
					"application/vnd.openxmlformats-officedocument.presentationml.presentation",
			},
			{ extension: ".rar", mime: "application/vnd.rar" },
			{ extension: ".rtf", mime: "application/rtf" },
			{ extension: ".sh", mime: "application/x-sh" },
			{ extension: ".svg", mime: "image/svg+xml" },
			{ extension: ".swf", mime: "application/x-shockwave-flash" },
			{ extension: ".tar", mime: "application/x-tar" },
			{ extension: ".ts", mime: "video/mp2t" },
			{ extension: ".ttf", mime: "font/ttf" },
			{ extension: ".txt", mime: "text/plain" },
			{ extension: ".vsd", mime: "application/vnd.visio" },
			{ extension: ".wav", mime: "audio/wav" },
			{ extension: ".weba", mime: "audio/webm" },
			{ extension: ".webm", mime: "video/webm" },
			{ extension: ".webp", mime: "image/webp" },
			{ extension: ".woff", mime: "font/woff" },
			{ extension: ".woff2", mime: "font/woff2" },
			{ extension: ".xhtml", mime: "application/xhtml+xml" },
			{ extension: ".xls", mime: "application/vnd.ms-excel" },
			{
				extension: ".xlsx",
				mime:
					"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
			},
			{ extension: ".xul", mime: "application/vnd.mozilla.xul+xml" },
			{ extension: ".zip", mime: "application/zip" },
			{ extension: ".3gp", mime: "video/3gpp" },
			{ extension: ".3g2", mime: "video/3gpp2" },
			{ extension: ".7z", mime: "application/x-7z-compressed" },
		];
		console.log("this.props.accept=", this.props.accept.split(","));
		console.log(
			"mimeTypes.find((y) =>y.mime===e.target.files[0].type).mime=",

			mimeTypes.find((y) => y.mime === e.target.files[0].type).mime
		);

		if (
			!this.props.accept
				.split(",")
				.includes(
					mimeTypes.find((y) => y.mime === e.target.files[0].type).extension
				)
		) {
			storeNotification.addNotification({
				title: "Selecting File",
				message: "Please select file with extension," + this.props.accept,
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return;
		}

		if (e.target.files[0].name) {
			console.log("e.target.files", e.target.files[0]);
			var filename = document.querySelector("#chooseFile" + this.props.fileName)
				.Value;
			if (/^\s*$/.test(filename)) {
				document
					.querySelector("#file-upload" + this.props.fileName)
					.classList.remove("active");
				document.querySelector("#noFile" + this.props.fileName).innerHTML =
					"No file chosen...";
			} else {
				document
					.querySelector("#file-upload" + this.props.fileName)
					.classList.add("class");
				document.querySelector("#noFile" + this.props.fileName).innerHTML =
					e.target.files[0].name;
			}
			console.log("choosefile props.state.auth.user=", this.props);

			let file = e.target.files[0];

			this.props.fileSelectionActions({ file: file, id: this.props.fileName });
		}
	}

	render() {
		return (
			<div
				className={"file-upload " + this.props.fileName}
				id={"file-upload" + this.props.fileName}
			>
				<div className="file-select">
					<div
						className="file-select-button"
						id={"fileName" + this.props.fileName}
					>
						Choose File
					</div>
					<div className="file-select-name" id={"noFile" + this.props.noFile}>
						No file chosen...
					</div>
					<input
						type="file"
						id={"chooseFile" + this.props.fileName}
						accept={this.props.accept}
						onChange={this.choosefileState}
					/>
					<div>
						<i className="fa fa-file" /> {this.state.filename}
					</div>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	fileSelectionActions: (file) => dispatch(fileSelectionActions(file)),
});

const mapStateToProps = (state) => ({ state });

export default connect(mapStateToProps, mapDispatchToProps)(Choosefile);
